import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { CardComponent } from './card/card.component';
import type { ColDef } from 'ag-grid-community';
import { PermissionDirective } from '../../shared/components/directives/permissions.directives';
import { Store } from '@ngrx/store';
import { DashboardService } from '../../features/dashboard/dashboard.service';
import { ContentLoaderComponent } from '../../shared/components/content-loader-component/contentLoader.component';
import { NoDataComponent } from '../../shared/components/no-data/nodata.component';
import * as selectPermissions from '../../core/permissions/permission.selector';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    FormsModule,
    CardComponent,
    PermissionDirective,
    ContentLoaderComponent,
    NoDataComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  public viewPortSize: boolean = false;
  public rowData: any[] | null = null;
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  public paginationPageSizeSelector: number[] | boolean = [10, 25, 50];
  public themeClass: string = 'ag-theme-quartz';
  public isPermission = true;
  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };

  loading = false;
  noData = false;
  columnDefs: any[] = [];
  dashboardData: any;

  constructor(
    private store: Store,
    private dashboardService: DashboardService
  ) {}

  ngOnInit(): void {
    this.checkViewportSize();
    this.permissionCheck();
    this.getDashboardCount();
  }

  permissionCheck() {
    this.store
      .select(selectPermissions.hasPermission('VIEW_DASHBOARD'))
      .subscribe((res) => {
        this.isPermission = res;
      });
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  getDashboardCount() {
    this.loading = true;
    this.dashboardService.getDashboardContents().subscribe({
      next: (res) => {
        this.dashboardData = res;
        this.loading = false;
        this.noData = false;
      },
      error: (err) => {
        this.noData = true;
        this.loading = false;
      },
    });
  }
}
